import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { oppref, trackPageView } from "@/lib/oaiq";

/** ChatGPT Ads page_viewed on every route, plus ChatGPT ad attribution capture on landing. */
export const OaiRouteTracking = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    oppref();
    trackPageView(pathname + search, document.title);
  }, [pathname, search]);
  return null;
};

export default OaiRouteTracking;
